import { RideStatusEnum, type IStationDto } from "@ryde/shared";

/**
 * A station created from the ride's add-station section, by quick add or the "+" drawer, is a plain stop:
 * neither a destination nor an official station.
 */
export const RIDE_ADD_STATION_NEW_STATION = {
  isDestination: false,
  metadata: { isOfficial: false },
} as const satisfies Partial<IStationDto>;

export const RIDE_BULK_MOVE_TARGET_STATUSES: readonly RideStatusEnum[] = [
  RideStatusEnum.New,
  RideStatusEnum.Sent,
  RideStatusEnum.Approved,
];

export const RIDE_BULK_MOVE_LABEL_DELIMITER = " | ";
export const RIDE_BULK_MOVE_AREAS_DELIMITER = " - ";

/** Station box widths inside `column_station_info` — header labels must match. */
export const RIDE_STATION_BOX_LEFT_WIDTH_PX = 30;
export const RIDE_STATION_BOX_RIGHT_WIDTH_PX = 81;

/** Max width for duration text + optional validation warning icon in the station row grid. */
export const RIDE_STATION_ROW_DURATION_COLUMN_MAX_WIDTH_PX = 78;

/** Shared desktop grid for station panel rows — keeps equal station column width across rows. */
export const RIDE_STATION_ROW_GRID_TEMPLATE =
  `minmax(0, 33px) minmax(0, 30px) minmax(0, 67px) minmax(0, 1fr) minmax(0, 130px) minmax(0, 28px) minmax(0, ${RIDE_STATION_ROW_DURATION_COLUMN_MAX_WIDTH_PX}px) minmax(0, 56px)` as const;

export const RIDE_STATION_ROW_GRID_GAP = "3px" as const;
